import { recipeMetaDataTransformerFS2QL } from "../../utils/RecipeBackEnd/hasuraFSMigrationTransformers";
import { SearchFilteredRecipesInterface } from "../search/search.types";
import { setAllRecipesData } from "./homepage.slice";
import { ingredientsObjectAdapter } from "./homepage.utils";

export const userLinkedDataHandler = (userLinkedData: any, cookClubLog: any) => {
  try {
    if (Array.isArray(userLinkedData?.devices) && userLinkedData.devices.length > 0) {
      return true
    }
    return false
  } catch (err) {
    cookClubLog(
      `Fetching User Linked Devices Failed`,
      "ERROR_ON_ACCESS_USER_LINKED_DEVICES",
      { err },
      { ui: { type: "error" }, browserConsole: true }
    );
  }
  return false
}

export const getAllRecipesDataHandler = (queryData: any) => (dispatch: any) => {
  const ingredientsData = queryData.ingredients ?? [];
  const ingredientsObject = ingredientsObjectAdapter(ingredientsData)
  const recipeMetaData = recipeMetaDataTransformerFS2QL(queryData?.recipes, queryData?.ingredients);

  let recipesIngredients: Array<string> = [];
  let recipeCuisines: Array<string> = [];
  let recipeMealTypes: Array<string> = [];

  recipeMetaData.forEach((recipe: SearchFilteredRecipesInterface) => {
    const processedIngredientsFilteredList: Array<string> = []
    recipe.metadata.ingredientsListIds.forEach((ingredientId: string) => {

      const displayName = ingredientsObject[ingredientId]?.displayName
      if (!displayName) return;

      const ingredientTags = ingredientsObject[ingredientId]?.tags
      if (ingredientTags?.includes('processed')) return;

      processedIngredientsFilteredList.push(displayName)
    })
    recipesIngredients = [...recipesIngredients, ...processedIngredientsFilteredList]
    recipeCuisines = [...recipeCuisines, ...recipe.metadata.tags]
    recipeMealTypes = [...recipeMealTypes, ...recipe.metadata.mealType]
  });

  const ingredientsList = [...new Set(recipesIngredients)].sort()
  const cuisinesList = [...new Set(recipeCuisines)].sort()
  const mealTypeList = [...new Set(recipeMealTypes)].sort()

  dispatch(setAllRecipesData({
    ingredientsData,
    recipeMetaData,
    ingredientsList,
    cuisinesList,
    mealTypeList
  }))
}